/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter} from "react-router";

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

class Link extends React.Component {
  static propTypes = {
    to: PropTypes.string,
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    onClick: null,
  };

  handleClick = event => {
    if (this.props.onClick) {
      this.props.onClick(event);
    }

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
      return;
    }

    if (event.defaultPrevented === true) {
      return;
    }
    event.preventDefault();
    if (
      this.props.editableLayout ||
      (this.props.editableBenchmark && !this.props.emptyBenchmark)
    ) {
      // eslint-disable-next-line no-restricted-globals
      const answer = confirm(
        'Are you sure you want to leave page without saving ?',
      );
      if (answer) {
        this.props.history.push(this.props.to);
      }
    } else {
      this.props.history.push(this.props.to);
    }
  };

  render() {
    const { to, children, ...props } = this.props;
    return (
      <div {...props} onClick={this.handleClick}>
        {children}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    editableLayout: state.routes.activeLayoutEdition,
    editableBenchmark: state.routes.activeBenchmarkEdition,
    emptyBenchmark: state.routes.emptyBenchmark,
  };
}
export default withRouter(connect(mapStateToProps)(Link));
